import { ColumnDef } from '@tanstack/react-table';
import { CompanyMembershipDto } from '@area-restrita/api-client/model/companyMembershipDto';

import UserDepartmentsCell from './UserDepartmentsCell';
import CompanyUsersActionsCell from './CompanyUsersActionsCell';

export { UserDepartmentsCell };

export const columns: ColumnDef<CompanyMembershipDto>[] = [
  {
    accessorKey: 'searchTerm',
    meta: { className: 'hidden' },
  },
  {
    accessorFn: ({ user }) => user.fullName ?? 'N/A',
    header: 'Nome completo',
  },
  {
    accessorFn: ({ user }) => user.email,
    header: 'E-mail',
  },
  {
    accessorKey: 'departments',
    header: 'Departamentos',
    cell: UserDepartmentsCell,
  },
  {
    accessorFn: ({ status }) => status,
    header: 'Status',
    cell: ({
      row: {
        original: { status },
      },
    }) =>
      [
        { label: 'Convidado', value: 'INVITE' },
        { label: 'Ativo', value: 'ACTIVE' },
        { label: 'Inativo', value: 'INACTIVE' },
      ].find((option) => option.value === status)?.label || 'N/A',
  },
  {
    header: 'Ações',
    meta: { className: 'text-right' },
    cell: CompanyUsersActionsCell,
  },
];
